import { render, staticRenderFns } from "./ChurchRecord.vue?vue&type=template&id=3dcea329&scoped=true&"
import script from "./ChurchRecord.vue?vue&type=script&lang=js&"
export * from "./ChurchRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcea329",
  null
  
)

export default component.exports